import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type ResponseBody } from '../react-query.config';

type AdminPickemsResponse = ResponseBody<'/api/admin/pickems', 'get'>;
export type Pickem = AdminPickemsResponse['pickems'][number];

interface GetPickemsParams {
  limit?: number;
  offset?: number;
  status?: string;
}

export const getPickems = (params?: GetPickemsParams) =>
  apiClient.get('/api/admin/pickems', { params });

export const useGetPickemsQuery = (params?: GetPickemsParams) => {
  return useQuery({
    queryKey: queryKeys.pickems.list(params),
    queryFn: () => getPickems(params),
    select: data => data.pickems || [],
  });
};
